// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2203":"525182989ea3f77ec4ae","2731":"b093a4afb7611f8c7c37"}[chunkId] + ".js";
};